import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class GeographicResponsibilityService {
  constructor(private httpClient: HttpClient) {}
  getGeographicList() {
    return this.httpClient.get(`GeographicalResponsibilities/getList`);
  }
  getCountryListBygeoId(id: string) {
    return this.httpClient.get(`GeographicalResponsibilities/find/${id}`);
  }
  updateGeoresponse(id, data) {
    return this.httpClient.patch(`GeographicalResponsibilities/${id}`, data);
  }

  deleteMapping(id) {
    return this.httpClient.delete(`GeographicalResponsibilityCountryMappings/${id}`, {});
  }
  // create
  createMapping(data) {
    return this.httpClient.post(`GeographicalResponsibilityCountryMappings`, data );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/geographic-responsibility.service.ts